/**
 * How much of a product the current user may see.
 *
 * States the fact, not what to draw for it: an upsold product shows the upsell
 * on the overview and a not-found deeper in, and the caller chooses which to
 * show. A hidden product shows no trace of itself anywhere.
 *
 * An enum rather than booleans plus a loading flag, so a caller cannot forget
 * the loading case and show the upsell to a paying customer.
 *
 * Lives apart from `useProductAccess` so a test can name a state without
 * importing the hook — and with it, the whole auth chain.
 */
export enum ProductAccess {
    LOADING = 'loading',
    /** The user may see the product. */
    LICENSED = 'licensed',
    /** The user is pitched the product: the default, and every unknown organisation. */
    DEFAULT = 'upsell',
    /** The product is set to Hidden: the customer sees nothing of it, not even its pitch. */
    HIDDEN = 'hidden',
}
